import React from "react";
import { BaseLayout } from "@layouts/BaseLayout";

import PageHero from "@shared/InnerPageHero";
import GetMeta from "@pages/SeoPages/GetMeta";

const CancellationPolicyPage = () => {
  return (
    <BaseLayout>
      <GetMeta
        description="Read Krent's Cancellation & Refund Policy to understand booking cancellations, refund eligibility, and processing timelines for guests and property partners."
        title="Cancellation Policy | Krent Inc"
        canonicalValue="cancellation-policy"
      />
      <section className="mb-5" style={{ marginTop: "-2rem" }}>
        <PageHero
          img="/assets/terms.jpg"
          currentPage="Cancellation Policy"
        />
      </section>
      <div className="container-fluid mb-5">
        <div className="container">
          <div className="text-center mb-5">
            <h1 className="fw-bolder">Cancellation Policy</h1>
            <div className="d-flex justify-content-center row">
              <p className="col-md-9 col-lg-7">
                Krent Cancellation &amp; Refund Policy — We aim to provide a
                fair and transparent experience for both guests and property
                partners.
              </p>
            </div>
          </div>
        </div>
      </div>
      <section className="mb-5 pb-5">
        <div className="container">
          <div className="d-flex flex-column justify-content-center col-md-9 mx-auto">
            <ol>
              <li className="mb-4">
                <h4 className="fw-bold">Instant Booking Cancellations</h4>
                <ul>
                  <li>
                    Cancellations made within 18 hours of booking may be
                    eligible for partial/full refund
                  </li>
                  <li>
                    Cancellations closer to check-in will attract penalties
                  </li>
                </ul>
              </li>

              <li className="mb-4">
                <h4 className="fw-bold">Non-Instant Booking (Key Policy)</h4>
                <ul>
                  <li>
                    If a booking is not confirmed within the 10-minute window,
                    it is automatically cancelled
                  </li>
                  <li>A full refund is initiated immediately</li>
                </ul>
              </li>

              <li className="mb-4">
                <h4 className="fw-bold">Host-Initiated Issues</h4>
                <p>If a host:</p>
                <ul>
                  <li>Fails to honor a confirmed booking</li>
                  <li>Provides inaccurate availability</li>
                </ul>
                <p className="mb-1">Guest receives:</p>
                <ul>
                  <li>Full refund</li>
                  <li>Possible relocation support</li>
                </ul>
              </li>

              <li className="mb-4">
                <h4 className="fw-bold">Refund Processing</h4>
                <ul>
                  <li>
                    Refunds are processed back to the original payment method
                  </li>
                  <li>
                    Timeline depends on payment provider (typically 0–72 hours)
                  </li>
                </ul>
              </li>

              <li className="mb-4">
                <h4 className="fw-bold">Non-Refundable Scenarios</h4>
                <ul>
                  <li>No-shows</li>
                  <li>Violations of property rules</li>
                  <li>Last-minute cancellations outside policy window</li>
                </ul>
              </li>
            </ol>

            <p className="mt-4">
              For questions about cancellations or refunds, contact us at{" "}
              <a href="mailto:hello@krent.space">hello@krent.space</a> or call{" "}
              09118008008.
            </p>
          </div>
        </div>
      </section>
    </BaseLayout>
  );
};

export default CancellationPolicyPage;
